import Axios from '@/axios'


export const action_log = function (data={}) {
  return Axios({
    url: '/adminapi/v1/action_log',
    method: 'post',
    data,
  })
}
